import { Truck, MapPin, AlertTriangle, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";

const fmtNum = (n) => Number(n || 0).toLocaleString("ro-RO");

export default function DeliveryCard({ data }) {
  if (!data) return null;
  const { delivery_rate_30d, avg_delivery_days, couriers = [], problematic_counties = [], counties = [], daily_7d = [] } = data;
  const top10 = counties.slice(0, 10);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="rounded-xl border border-border bg-white p-5 lg:col-span-2" data-testid="delivery-trend-card">
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="flex items-center gap-2">
              <Truck className="h-4 w-4 text-violet-600" />
              <h3 className="font-display font-semibold text-base">Livrări — ultima săptămână</h3>
            </div>
            <p className="text-xs text-muted-foreground mt-0.5">
              Rată livrare 30d: <span className="font-semibold text-foreground tabular-nums">{Number(delivery_rate_30d || 0).toFixed(1)}%</span> · Timp mediu: <span className="font-semibold text-foreground tabular-nums">{Number(avg_delivery_days || 0).toFixed(1)} zile</span>
            </p>
          </div>
          <Link to="/livrari" className="text-xs text-primary hover:underline">Vezi detalii →</Link>
        </div>
        <ResponsiveContainer width="100%" height={140}>
          <AreaChart data={daily_7d}>
            <defs>
              <linearGradient id="dlvFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#8b5cf6" stopOpacity={0.5} />
                <stop offset="100%" stopColor="#8b5cf6" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="day" hide />
            <Tooltip
              contentStyle={{ background: "white", border: "1px solid #e4e4e7", borderRadius: 8, fontSize: 12 }}
              labelStyle={{ fontSize: 11, color: "#71717a" }}
            />
            <Area type="monotone" dataKey="orders" stroke="#8b5cf6" strokeWidth={2} fill="url(#dlvFill)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="rounded-xl border border-border bg-white p-5" data-testid="delivery-problems-card">
        <div className="flex items-center gap-2 mb-3">
          <AlertTriangle className="h-4 w-4 text-rose-600" />
          <h3 className="font-display font-semibold text-base">Județe problematice</h3>
        </div>
        {problematic_counties.length === 0 ? (
          <div className="text-xs text-muted-foreground py-6 text-center">Nicio anomalie semnalată.</div>
        ) : (
          <div className="space-y-2">
            {problematic_counties.map((c) => (
              <div key={c.county || c.name} className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-2 min-w-0">
                  <MapPin className="h-3 w-3 text-rose-500 shrink-0" />
                  <span className="truncate">{c.county || c.name}</span>
                </div>
                <span className="text-xs tabular-nums text-rose-600">{Number(c.refusal_rate || c.refused_rate || c.rate || 0).toFixed(0)}% refuz</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="rounded-xl border border-border bg-white p-5 lg:col-span-3" data-testid="delivery-counties-card">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-display font-semibold text-base">Top județe (volum comenzi 30d)</h3>
          <Link to="/analytics" className="text-xs text-primary hover:underline">Heatmap complet →</Link>
        </div>
        {top10.length === 0 ? (
          <div className="text-xs text-muted-foreground py-6 text-center">Fără date.</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
            {top10.map((c, idx) => (
              <div key={c.county || c.name || idx} className="rounded-lg border border-border bg-zinc-50 px-3 py-2">
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground truncate">{c.county || c.name}</div>
                <div className="font-display font-bold tabular-nums mt-1">{fmtNum(c.orders || c.count)}</div>
                {c.delivery_rate != null && (
                  <div className="text-[10px] text-emerald-600 mt-0.5 tabular-nums">{Number(c.delivery_rate).toFixed(0)}% livrate</div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
